import { css } from '@emotion/react'
import { IdadeGestacionalAcompanhamentoPreNatal } from '@soap/aside/pre-natal/model-acompanhamentoPreNatal'
import { Button, HFlow, Icon, Tag, Text, Tooltip, VFlow } from 'bold-ui'
import { purple } from 'bold-ui/lib/styles/colors'
import { resolveName } from 'components/form'
import { FonteIdadeGestacionalEnum } from 'graphql/types.generated'
import { ReactComponent as CalculateIcon } from 'images/soap/calculate-outline.svg'
import { useState } from 'react'
import { useField } from 'react-final-form'
import { meta as metaSoapState } from 'view/atendimentos/atendimento-individual/model'

import { FonteIdadeGestacionalModalForm } from './FonteIdadeGestacionalModalForm'
import { FonteIdadeGestacionalFormModel } from './model-fonteIg'
import { calcularFonteIgRecomendada } from './util-fonteIdadeGestacional'

interface FonteIdadeGestacionalSectionProps {
  persistedFonteIg?: FonteIdadeGestacionalEnum
}

export const FonteIdadeGestacionalSection = (props: FonteIdadeGestacionalSectionProps) => {
  const { persistedFonteIg } = props

  const [isModalOpen, setIsModalOpen] = useState(false)
  const styles = createStyles()

  const {
    input: { value: { cronologicaEmDias: igDum, ecograficaEmDias: igEco } = {} },
  } = useField<IdadeGestacionalAcompanhamentoPreNatal>(
    resolveName(metaSoapState.acompanhamentoPreNatal.idadeGestacional)
  )

  const recommendedFonteIg = calcularFonteIgRecomendada(igDum, igEco)

  const {
    input: { value: currentFonteIg, onChange },
  } = useField<FonteIdadeGestacionalEnum>(resolveName(metaSoapState.preNatal.fonteIdadeGestacional), {
    initialValue: persistedFonteIg ?? FonteIdadeGestacionalEnum.DUM,
  })

  const currentFonteIgText = currentFonteIg === FonteIdadeGestacionalEnum.DUM ? 'DUM' : 'Ecografia Obstétrica'

  const handleSave = (newValue: FonteIdadeGestacionalFormModel) => {
    onChange(newValue.fonteIg)
    setIsModalOpen(false)
  }

  return (
    <VFlow>
      <VFlow>
        <HFlow hSpacing={0.5} alignItems='center' justifyContent='flex-start'>
          <CalculateIcon />
          <Text component='h4' fontWeight='bold'>
            Cálculo da idade gestacional
          </Text>
        </HFlow>
        <HFlow alignItems='center'>
          <Tag icon='checkCircleOutline' style={styles.tagGestantes}>
            Idade gestacional pela {currentFonteIgText}
          </Tag>
          <Tooltip
            text={!igEco ? 'Para alterar é necessário registrar o resultado de uma ultrassonografia obstétrica' : ''}
          >
            <Button kind='primary' size='small' skin='outline' onClick={() => setIsModalOpen(true)} disabled={!igEco}>
              <Icon icon='penOutline' style={styles.icon} />
              Alterar forma de cálculo
            </Button>
          </Tooltip>
        </HFlow>
      </VFlow>
      {isModalOpen && (
        <FonteIdadeGestacionalModalForm
          onClose={() => setIsModalOpen(false)}
          onSave={handleSave}
          recommendedFonteIg={recommendedFonteIg}
          currentFonteIg={currentFonteIg}
          igDum={igDum}
          igEco={igEco}
        />
      )}
    </VFlow>
  )
}

const createStyles = () => ({
  tagGestantes: css`
    background-color: ${purple.c90};
    color: ${purple.c40};
  `,
  icon: css`
    margin-right: 0.5rem;
  `,
})
